define([
    'underscore',
    'edge/quoteandbind/common/models/Submission',
    'edge/quoteandbind/pa/models/Driver',
    'edge/quoteandbind/common/models/Person',
    'edge/quoteandbind/pa/models/Vehicle'
], (_, Submission, Driver, Person, Vehicle, DriverProcessService)=> {
    let nextId;

    let PASubmissionDraftDataExtension = function (submission) {
        nextId = submission.nextId;

        let data = submission.draftData.lobs.personalAuto;
        //const accountHolder = submission.draftData.accountHolder;
        //console.log("PA Submission AccountHolder:: ",accountHolder);
        
        // Add account holder in the prototype
        this.accountHolder = submission.draftData.accountHolder;
        
        if (data && _.isObject(data)) {
            this.drivers = _.map(data.drivers, (d)=> {
               
                let driver = new Driver(d);
                if(d.person){
                driver.person = submission.findPerson(submission, d.person);}
                if((driver.socialSecurityNumber)&&(driver.socialSecurityNumber.indexOf("*")) < 0){
                    driver.ssnunMasked=angular.copy(driver.socialSecurityNumber);
                }
               if(driver.socialSecurityNumber){
               var ssnvalid=driver.socialSecurityNumber;
                ssnvalid=ssnvalid.substring(0,3).replace(/\d/gi,'*') + '-' + ssnvalid.substring(4,6).replace(/\d/gi,'*') + '-' + ssnvalid.substring(7,11)
                driver.socialSecurityNumber = ssnvalid;
            }
                return driver;
            
        }, this);
        

            this.vehicles = _.map(data.vehicles, (v)=> {
                return new Vehicle(v);
            }, this);
            // ENHC0011961_EODB QnB Defaults - added membership details 
            this.membershipPA = data.membershipPA;
            // ended
            this.preQualQuestionSets = data.preQualQuestionSets;
        } else {
            this.drivers = [];
            this.vehicles = [];
            this.preQualQuestionSets = [];
            // ENHC0011961_EODB QnB Defaults - added membership details 
            this.membershipPA = {};
            //ended
        }
    };

    PASubmissionDraftDataExtension.prototype.createDriver = function (person) {
        const driver = new Driver({
            person,
            dateOfBirth: person.dateOfBirth
        });
        // extend
        if (person && person.primaryAddress) {
            driver.licenseState = person.primaryAddress.state;

        }
        
        driver.tempID = nextId();     

        //ssn
        driver.ssnunMasked = "";
        driver.socialSecurityNumber = "";
        
        // Set state code for all drivers
        driver.accountHolderState = this.accountHolder.primaryAddress.state;
        
        driver.inExperiencedDriver = false;
        
        driver.isAddAccidentValid = true;
        driver.isEditAccidentValid = true;
        
        // Defaulting drive status as "Rated" for all drivers
        driver.driverStatus = "Rated";
        
        // Set empty list for accident voilation list and accident portal list
        driver.accidentVoilationList = [];
        driver.accidentVoilationPortalList = [];
        driver.drivesTheVehicle = false;
        //ENHC0011961_EODB QnB Defaults --Arpita Sengupta
        driver.maritialStatus = "S";
        driver.educationalLevel = "highschool";
        // driver.firstLicensed = "16";
        driver.accidentsInLast3Years = false;
        //ended
        //driver.accid,entVoilationPortalList = DriverProcessService.mapAccidentListToPortal(driver.accidentVoilationList, driver.accountHolderState);
        
        // Set account holder value if driver is primay driver
        if (person &&  person.accountHolder){
            driver.isAccountHolder = true;
        }
        else{
            driver.isAccountHolder = false;
        }
        //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
        if(driver.isAccountHolder && driver.person.occupation != null){
            driver.occupation = driver.person.occupation;
        }else{
            driver.occupation = "othersnotlisted";
        }
        if(driver.isAccountHolder && driver.person.payGrade != null){
            driver.payGrade = driver.person.payGrade;
        }
           
        //console.log("Driver:: ",driver);
        
        /**
             * Defect : DFCT0016955 - GPA – SC Auto Date First Licensed Rules no Longer Working (reference CHG00328640)
             * Developer : Devnandan Kumar*/
        if (driver.accountHolderState === 'SC') {
            driver.minAge = 15 ;
        }
        else {
            driver.minAge = 16;
        }
        this.drivers.push(driver);
        return driver;
    };

    PASubmissionDraftDataExtension.prototype.removeDriver = function (driver) {
        const idx = _.indexOf(this.drivers, driver);
        if (idx >= 0) {
            this.drivers.splice(idx, 1);
        }
    };

    PASubmissionDraftDataExtension.prototype.createVehicle = function (person) {
        const v = new Vehicle({tempID: nextId()});
        if (person && person.primaryAddress) {
            v.licenseState = person.primaryAddress.state;
        }
        //console.log("The account holderstate is",this.accountHolder)
        v.accountHolderState = this.accountHolder.primaryAddress.state;
        //v.inExpDriver = []
        // ENHC0011961_EODB QnB Defaults --Arpita Sengupta 
        v.primaryUse = "pleasure";
        v.tmpPrimeUse = "Personal";
        v.tmpPaType="auto";
        v.regularlyParked = true;
        v.isCustomizedVehicle = false;
        v.salvageTitle = false;
        v.damageInAccident = false;
        //ended
        this.vehicles.push(v);
        return v;
    };

    PASubmissionDraftDataExtension.prototype.removeVehicle = function (vehicle) {
        const idx = _.indexOf(this.vehicles, vehicle);
        if (idx >= 0) {
            this.vehicles.splice(idx, 1);
        }
    };

    PASubmissionDraftDataExtension.prototype.getDriverForPerson = function (person) {
        const driver = _.findWhere(
            this.drivers, {person}
        );

        if (driver.dateOfBirth !== person.dateOfBirth) {
            driver.dateOfBirth = person.dateOfBirth;
        }

        return driver;
    };

    return PASubmissionDraftDataExtension;
}
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/models/PASubmissionDraftDataExtension.js
 **/